webpackJsonp([119,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ThemeAqyActivity = __webpack_require__(729);
	
	var _ThemeAqyActivity2 = _interopRequireDefault(_ThemeAqyActivity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	    el: '#home-app',
	    template: '<HomeApp/>',
	    components: { HomeApp: _ThemeAqyActivity2.default }
	});

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    isMobile: function isMobile(num) {
	        var reg = /^\d{11}$/;
	        return reg.test(num);
	    },
	    isGuangdiantongChannel: function isGuangdiantongChannel(channelid) {
	        var reg = /\d{1}03\d{7}/;
	        return reg.test(channelid);
	    },
	    isSuozhiChannel: function isSuozhiChannel(channelid) {
	        var reg = /\d{1}13\d{7}/;
	        return reg.test(channelid);
	    },
	    isNewChannel: function isNewChannel(channelid) {
	        var newChannels = ["1050528003", "1020526004", "1050528004", "2080123001", "2120123001", "1050528001", "1140510007", "1020526001", "2050128001", "1020526002", "2080110002", "2120127002", "2050120001", "1020526005", "1050528002", "1020526003", "3050228001", "1010715010", "1050529005", "1050515022", "1030516026", "1050610020", "1050515020", "1050529003", "1050529004", "1050529005", "1050529003", "1050529004", "2050129001", "1050529006", "3050229001", "1050529001", "1050529002", "1010516024", "1050523006", "1030518010", "1050523005", "1050528006", "1050528007", "1010516025", "1010715007", "1050515023", "1050523002", "2050129001", "1050521006", "1050610019", "1050523001", "1010715009", "1050528005", "1010715008", "1030518011", "1010715011", "1050529001", "1010518017", "1050521005", "3050223001", "1010516026", "1050515021", "1050523003", "1050529002", "1050523004", "2050123001", "1050521007", "1030516027", "1050610021"];
	        return newChannels.indexOf(channelid) > -1;
	    },
	    isKAChannel: function isKAChannel(channelid) {
	        var newChannels = ["3050229003", "1050529005", "1050529010", "1050529011", "1050529003", "1050529004", "1050529014", "1050529007", "1050529009", "2050129001", "1050529006", "3050229001", "1050529001", "3050229002", "1050529013", "1050529012", "1050529002", "1050529008", "3050229004", "1050531004", "3050231001", "1050531002", "1050531005", "1050531003", "1050531009", "2050131001", "1050531008", "1050531001", "1050531007", "1050531006", "1050610014", "1050521012", "1050528002", "1050523007", "1050523002"];
	        return newChannels.indexOf(channelid) > -1;
	    },
	    isKuaishouChuangyan: function isKuaishouChuangyan(channelid) {
	        var reg = /\d{1}02\d{2}26\d{3}/;
	        return reg.test(channelid);
	    },
	    isTuiaChannel: function isTuiaChannel(channelid) {
	        var reg = /\d{1}05\d{7}/;
	        return reg.test(channelid);
	    },
	    isToutiaoChannel: function isToutiaoChannel(channelid) {
	        var reg = /\d{1}01\d{7}/;
	        return reg.test(channelid);
	    },
	
	    isEmpty: function isEmpty(content) {
	        if (content != null && content != "" && content != "undefined" && content != "null" && content != "unknown") {
	            return false;
	        } else {
	            return true;
	        }
	    },
	
	    getQueryString: function getQueryString(name) {
	        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	        var r = window.location.search.substr(1).match(reg);
	        if (r != null) {
	            return unescape(decodeURI(r[2]));
	        }
	        return null;
	    },
	
	    getAdvertId: function getAdvertId() {
	        var aOld = this.getQueryString('a_oId') ? this.getQueryString('a_oId') : '';
	        var clickid = this.getQueryString('clickid') ? this.getQueryString('clickid') : '';
	        var trackId = this.getQueryString('track_id') ? this.getQueryString('track_id') : '';
	        var callbackUrl = this.getQueryString('callback_url') ? this.getQueryString('callback_url') : this.getQueryString('callback') ? this.getQueryString('callback') : '';
	        var callbackParam = this.getQueryString('callback_param') ? this.getQueryString('callback_param') : '';
	        var bxmId = this.getQueryString('bxm_id') ? this.getQueryString('bxm_id') : '';
	        var advertId = this.getQueryString('advert_id') ? this.getQueryString('advert_id') : '';
	        var gdtId = this.getQueryString('qz_gdt') ? this.getQueryString('qz_gdt') : this.getQueryString('gdt_vid') ? this.getQueryString('gdt_vid') : '';
	        var xmobId = this.getQueryString('userkey') ? this.getQueryString('userkey') + '|' + this.getQueryString('plid') : '';
	        var jcId = this.getQueryString('jcid') ? this.getQueryString('jcid') : '';
	        var bdId = this.getQueryString('bd_vid') ? this.getQueryString('bd_vid') : '';
	        var oId = this.getQueryString('oId') ? this.getQueryString('oId') : '';
	        var searchId = this.getQueryString('searchId') ? this.getQueryString('searchId') : '';
	        var landingid = this.getQueryString('landingid') ? this.getQueryString('landingid') : '';
	        var szRli = this.getQueryString('sz_rli') ? this.getQueryString('sz_rli') : '';
	        var nadKey = this.getQueryString('nadkey') ? this.getQueryString('nadkey') : '';
	        var qcjParamStr = this.getQueryString('qcjParamStr') ? this.getQueryString('qcjParamStr') : '';
	        var clickTag = this.getQueryString('click_tag') ? this.getQueryString('click_tag') : '';
	        var adClick = this.getQueryString('bcx_cli') ? this.getQueryString('bcx_cli') : '';
	        var basicPara = this.getQueryString('basic_para') ? this.getQueryString('basic_para') : '';
	        var ccbid = this.getQueryString('ccbid') ? this.getQueryString('ccbid') : '';
	        var requestId = this.getQueryString('requestId') ? this.getQueryString('requestId') : '';
	        var adExposureId = this.getQueryString('adExposureId') ? this.getQueryString('adExposureId') : '';
	        var qhclickid = this.getQueryString('qhclickid') ? this.getQueryString('qhclickid') : '';
	        return aOld + clickid + trackId + callbackUrl + callbackParam + bxmId + advertId + gdtId + xmobId + jcId + bdId + oId + searchId + landingid + szRli + nadKey + qcjParamStr + clickTag + adClick + basicPara + ccbid + requestId + adExposureId + qhclickid;
	    },
	    getUnionSite: function getUnionSite() {
	        var unionSite = this.getQueryString("union_site") ? this.getQueryString("union_site") : '';
	        var appId = this.getQueryString("promoted_object_id") ? this.getQueryString("promoted_object_id") : '';
	        return unionSite + appId;
	    },
	
	    getBaseUrl: function getBaseUrl() {
	        var urlString = window.location.href;
	        if (urlString.startsWith('https://qiaos.gzjxwlkj.cn')) {
	            return 'https://qiaos.gzjxwlkj.cn/qiaosi';
	        } else if (urlString.startsWith('https://szyxb31.xwtec.cn')) {
	            return 'https://szyxb31.xwtec.cn/qiaosi';
	        } else if (urlString.startsWith('https://qiaos.zhonglianhuashu.com')) {
	            return 'https://qiaos.zhonglianhuashu.com/qiaosi';
	        } else if (urlString.startsWith('https://rz1014.laidianbanlv.cn')) {
	            return 'https://rz1014.laidianbanlv.cn/qiaosi';
	        } else if (urlString.startsWith('https://kh1208.laidianbanlv.cn/')) {
	            return 'https://kh1208.laidianbanlv.cn/qiaosi';
	        } else if (urlString.startsWith('https://qs101.banlianghao.com')) {
	            return 'https://qs101.banlianghao.com/qiaosi';
	        } else {
	            return 'http://47.119.164.132:8080/qiaosi';
	        }
	    },
	    getHost: function getHost() {
	        var urlString = window.location.href;
	        var index = urlString.indexOf("/", 10);
	        return urlString.substring(0, index + 1);
	    },
	
	    setCookieTime: function setCookieTime(key, value, time) {
	        value = this.setEscape(value);
	        var exp = new Date();
	        exp.setTime(exp.getTime() + time * 60000);
	        document.cookie = key + "=" + value + ";expires=" + exp.toGMTString() + ";path=/";
	    },
	    setEscape: function setEscape(content) {
	        return encodeURI(content);
	    },
	    getUuid: function getUuid() {
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	            var r = Math.random() * 16 | 0,
	                v = c == 'x' ? r : r & 0x3 | 0x8;
	            return v.toString(16);
	        });
	    }
	};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'MessageBox',
	    props: ['isloading', 'msg', 'flag']
	};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(4)
	
	/* script */
	__vue_exports__ = __webpack_require__(3)
	
	/* template */
	var __vue_template__ = __webpack_require__(6)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0f895ed7"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isloading),
	      expression: "isloading"
	    }],
	    staticClass: "mask-white-dialog",
	    staticStyle: {
	      "z-index": "9999"
	    }
	  }, [_c('div', {
	    staticClass: "m-loading"
	  }, [(_vm.flag) ? _c('div', {
	    staticClass: "loading-icon"
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "loading-txt"
	  }, [_vm._v(_vm._s(_vm.msg == '' ? "数据加载中..." : _vm.msg))])])])
	},staticRenderFns: []}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'QuitModal',
	    props: ['showQuitModal', 'activityImgSrc', 'btnImgSrc', 'toUrl'],
	    methods: {
	        toFreeGet: function toFreeGet() {
	            window.location.href = this.toUrl;
	        },
	        preventDefault: function preventDefault(e) {
	            e.stopPropagation();
	        },
	        closeQuitModal: function closeQuitModal() {
	            this.$emit("closeQuitModal");
	        }
	    }
	};

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(24)
	
	/* script */
	__vue_exports__ = __webpack_require__(23)
	
	/* template */
	var __vue_template__ = __webpack_require__(26)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3d42604a"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showQuitModal),
	      expression: "showQuitModal"
	    }],
	    staticClass: "pop-quit",
	    on: {
	      "click": _vm.closeQuitModal
	    }
	  }, [_c('div', {
	    staticClass: "pop-body",
	    on: {
	      "click": _vm.preventDefault
	    }
	  }, [_c('img', {
	    staticClass: "img",
	    attrs: {
	      "src": _vm.activityImgSrc
	    },
	    on: {
	      "click": _vm.toFreeGet
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'RecomBox',
	    props: ['showQuitModal', 'productName', 'toUrl'],
	    data: function data() {
	        return {
	            time: 3
	        };
	    },
	    created: function created() {},
	    mounted: function mounted() {},
	
	    watch: {
	        showQuitModal: function showQuitModal(now, old) {
	            if (now) {
	                this.timer();
	            }
	
	            if (old) {
	                var _this = this;
	                _this.time = 3;
	            }
	        },
	        time: function time(now, old) {
	            var _this = this;
	            if (now == 0 && _this.showQuitModal) {} else {}
	        }
	    },
	    methods: {
	        toFreeGet: function toFreeGet() {
	            window.location.href = this.toUrl;
	        },
	        preventDefault: function preventDefault(e) {
	            e.stopPropagation();
	        },
	        closeRecomBox: function closeRecomBox() {
	            this.$emit("closeRecomBox");
	        },
	        jump: function jump() {
	            window.location.href = this.toUrl;
	        },
	        timer: function timer() {
	            var _this = this;
	            var t = setInterval(function () {
	                if (_this.time > 0) {
	                    _this.time--;
	                } else {
	                    clearInterval(t);
	                    window.location.href = _this.toUrl;
	                }
	            }, 1000);
	        }
	    }
	};

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(28)
	
	/* script */
	__vue_exports__ = __webpack_require__(27)
	
	/* template */
	var __vue_template__ = __webpack_require__(30)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-eb3ce560"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 30:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showQuitModal) ? _c('div', {
	    staticClass: "pop-recom"
	  }, [_c('div', {
	    staticClass: "pop-body",
	    on: {
	      "click": _vm.preventDefault
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('p', [_vm._v("非常抱歉，本业务暂不支持办理，推荐办理更优惠产品: " + _vm._s(_vm.productName))])]), _vm._v(" "), _c('div', {
	    staticClass: "button",
	    on: {
	      "click": _vm.jump
	    }
	  }, [_vm._v("点击查看" + _vm._s(_vm.time) + "s")])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('p', [_vm._v("温馨提示")])])
	}]}

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(31);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	__webpack_require__(2);
	
	__webpack_require__(7);
	
	var _MessageBox = __webpack_require__(5);
	
	var _MessageBox2 = _interopRequireDefault(_MessageBox);
	
	var _QuitModal = __webpack_require__(25);
	
	var _QuitModal2 = _interopRequireDefault(_QuitModal);
	
	var _RecomBox = __webpack_require__(29);
	
	var _RecomBox2 = _interopRequireDefault(_RecomBox);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseMethod = __webpack_require__(1);
	
	var _baseMethod2 = _interopRequireDefault(_baseMethod);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'product',
	    components: {
	        "qs-msg-box": _MessageBox2.default,
	        "qs-quit-modal": _QuitModal2.default,
	        "qs-recom-box": _RecomBox2.default
	
	    },
	    created: function created() {
	        var _this = this;
	
	        _this.channelid = _baseMethod2.default.getQueryString("channelid") ? _baseMethod2.default.getQueryString("channelid") : '18000000';
	        _this.unionSite = _baseMethod2.default.getUnionSite();
	        _this.advertId = _baseMethod2.default.getAdvertId();
	
	        _this.productId = _baseMethod2.default.getQueryString("product") ? _baseMethod2.default.getQueryString("product") : "XWPBM1Q74";
	        _this.group = _baseMethod2.default.getQueryString("group");
	        _this.topImgSrc = "https://resource.0168.net.cn/activity-mall/woread/theme1/top_all.jpg";
	        _this.quitToUrl = _this.quitToUrl + "?channelid=" + _this.channelid;
	
	        _this.init();
	        _this.getPageUrl();
	        window.addEventListener('scroll', this.bindScroll);
	
	        setTimeout(function () {
	            _this.flag2s = false;
	        }, 1500);
	
	        setTimeout(function () {
	            _this.indexshow = false;
	        }, 2500);
	
	        if (localStorage.getItem("hy_order_expire") && localStorage.getItem("hy_order_expire") > new Date().getTime()) {
	            var orderId = localStorage.getItem("hy_order_id");
	            window.parent.location.href = "https://store.0168.net.cn/activity-mall/cl/result_hy.html?orderId=" + orderId;
	        }
	    },
	    data: function data() {
	        return {
	            indexshow: true,
	            flag2s: true,
	            topImgSrc: "",
	            inputBgImgSrc: "https://resource.0168.net.cn/activity-mall/h5/theme3/input_bg.jpg",
	            inputBgImgSrc1_2: "https://resource.0168.net.cn/activity-mall/h5/theme3/input_bg1.jpg",
	            productName: "",
	            visibleNotes: true,
	            showQuestion: false,
	            showPrivacy: true,
	            isDis: false,
	            isLoading: false,
	            msg: '加载中。。。',
	            flag: false,
	            phonenum: '',
	            channelid: '',
	            unionSite: '',
	            wokey: '',
	            advertId: '',
	            productId: '',
	            group: '',
	            trace: '',
	            capUrl: '',
	            productUrl: '',
	            btnFixed: false,
	            showQuitModal: false,
	            showRecomBox: false,
	            recomProduct: "",
	            recomUrl: "",
	            quitActivityImgSrc: "https://resource.0168.net.cn/activity-mall/5Gn/image/5Gn_activity.png",
	            quitBtnImgSrc: "https://resource.0168.net.cn/activity-mall/5Gn/image/5Gn_get_btn.png",
	            quitToUrl: "https://store.0168.net.cn/activity-mall/5Gn/index.html",
	            getInfo: ['130 **** 9493 已领取爱奇艺会员 &nbsp;&nbsp;&nbsp;&nbsp;2分钟前', '155 **** 9512 已领取芒果TV会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;2分钟前', '130 **** 2181 已领取饿了么超级会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;3分钟前', '132 **** 3279 已领取腾讯会员 &nbsp;&nbsp;&nbsp;&nbsp;4分钟前', '132 **** 6917 已领取爱奇艺黄金会员 &nbsp;&nbsp;&nbsp;&nbsp;5分钟前', '155 **** 5511 已领取芒果TV会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;5分钟前', '131 **** 7510 已领取爱奇艺黄金会员 &nbsp;&nbsp;&nbsp;&nbsp;6分钟前', '131 **** 1495 已领取百度网盘会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;7分钟前', '130 **** 1043 已领取爱奇艺会员 &nbsp;&nbsp;&nbsp;&nbsp;9分钟前', '186 **** 1905 已领取哔哩哔哩会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;9分钟前', '155 **** 2309 已领取优酷视频会员 &nbsp;&nbsp;&nbsp;&nbsp;10分钟前'],
	            checked: false,
	            timesCount: 0,
	            captcha: '',
	            mode: "0",
	            data: {},
	            mifaChannel: ['450001', '410001', '420001'],
	            youzhengChannel: ['680001', '680002'],
	            orderId: "",
	            step: 1
	        };
	    },
	
	    watch: {
	        phonenum: function phonenum(now, old) {
	            if (now.length == 11 && old.length == 10 && !_baseMethod2.default.isGuangdiantongChannel(this.channelid)) {
	                var _this = this;
	                _this.checked = true;
	                _this.bindOpen();
	            }
	        }
	    },
	    methods: {
	        bindScroll: function bindScroll() {
	            this.scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
	            if (this.scrollHeight > 600) {
	                this.btnFixed = true;
	            } else {
	                this.btnFixed = false;
	            }
	        },
	        togg: function togg() {
	            return this.isDis === false ? 'display:none' : 'display:block';
	        },
	        bindOpen: function bindOpen() {
	            var _this = this;
	
	            if (!_this.checked) {
	                _this.showMsg("请勾选同意隐私协议及相关条款");
	                return;
	            }
	
	            if (_this.timesCount != 0) {
	                if (_baseMethod2.default.isEmpty(_this.captcha)) {
	                    _this.showMsg("验证码不能为空！");
	                    return;
	                }
	                _this.subCode();
	                return;
	            }
	
	            if (_this.btnFixed) {
	                document.getElementById('inputPhone').focus();
	                return;
	            }
	
	            if (!_baseMethod2.default.isMobile(_this.phonenum)) {
	                _this.showMsg("请输入正确的手机号码");
	                return;
	            }
	
	            var params = {
	                product: _this.productId,
	                channel_id: _this.channelid,
	                tel: _this.phonenum,
	                advert_id: _this.advertId,
	                union_site: _this.unionSite,
	                wokey: _this.wokey,
	                request: window.location.href,
	                preelection: _this.productUrl
	            };
	
	            _this.isDis = true;
	            _jquery2.default.ajax({
	                url: 'https://api.0168.net.cn/qiaosi/product/v2/payment',
	                type: 'get',
	                dataType: 'json',
	                data: params,
	                success: function success(res) {
	                    _this.isDis = false;
	                    if (res.code.startsWith("01")) {
	                        _this.mode = "1";
	                        _this.capUrl = res.data.pay_url;
	                        _this.step = 0;
	                        (0, _jquery2.default)("#cap").slideDown(500);
	                    } else if (res.code.startsWith("02")) {
	                        _this.mode = "3";
	                        _this.step = 2;
	                        _this.orderId = res.order_id;
	                        _this.timesCount = 60;
	                        var time = setInterval(function () {
	                            if (_this.timesCount == 0) {
	                                clearInterval(time);
	                            } else {
	                                _this.timesCount--;
	                            }
	                        }, 1000);
	                    } else if (res.code.startsWith("04")) {
	                        window.location.href = res.data.pay_url;
	
	                        localStorage.setItem('hy_order_id', res.order_id);
	                        localStorage.setItem('hy_order_expire', new Date().getTime() + 3 * 60 * 1000);
	                    } else if (res.code.startsWith("07")) {
	                        window.location.href = res.data.pay_url;
	                    } else {
	                        _this.isDis = false;
	                        _this.showMsg(res.msg);
	                    }
	                },
	                error: function error(res) {
	                    _this.isDis = false;
	                    _this.showMsg("系统繁忙，请稍后再试！");
	                }
	            });
	        },
	        subCode: function subCode() {
	            var _this = this;
	
	            if (_this.btnFixed) {
	                document.getElementById('inputPhone').focus();
	                return;
	            }
	
	            if (!_baseMethod2.default.isMobile(_this.phonenum)) {
	                _this.showMsg("请输入正确的手机号码");
	                return;
	            }
	            var params = {
	                "order_id": _this.orderId,
	                "code": _this.captcha
	            };
	            _this.isDis = true;
	            _jquery2.default.ajax({
	                url: 'https://api.0168.net.cn/qiaosi/product/code',
	                type: 'post',
	                dataType: 'json',
	                contentType: 'application/json',
	                data: (0, _stringify2.default)(params),
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                success: function success(res) {
	                    _this.isDis = false;
	                    if (res.code.startsWith("5") || res.code.startsWith("4")) {
	                        _this.showMsg(res.msg);
	                    } else if (res.code.startsWith("6")) {
	                        _this.showMsg(res.msg);
	                        window.parent.location.href = res.returl;
	                    } else if (res.code == '00000') {
	                        window.parent.location.href = res.returl;
	                    }
	                },
	                error: function error(res) {
	                    _this.isDis = false;
	                    _this.showMsg("系统繁忙，请稍后再试！");
	                }
	            });
	        },
	        agreePrivacy: function agreePrivacy() {
	            var _this = this;
	            _this.checked = true;
	            _this.showPrivacy = true;
	        },
	        showPrivacyBoxOrNot: function showPrivacyBoxOrNot() {
	            var _this = this;
	            _this.showPrivacy = !_this.showPrivacy;
	        },
	        iKnow: function iKnow() {
	            var _this = this;
	            _this.checked = true;
	            _this.onFoucs();
	        },
	        showMsg: function showMsg(msg) {
	            var _this = this;
	            _this.isLoading = true;
	            _this.msg = msg;
	
	            setTimeout(function () {
	                _this.isLoading = false;
	            }, 1000);
	        },
	        closeQuitModal: function closeQuitModal() {
	            var _this = this;
	            _this.showQuitModal = false;
	        },
	        closeRecomBox: function closeRecomBox() {
	            var _this = this;
	            _this.showRecomBox = false;
	        },
	        showActivityOrNot: function showActivityOrNot() {
	            var _this = this;
	            _this.visibleNotes = !_this.visibleNotes;
	        },
	        onFoucs: function onFoucs() {
	            document.getElementById('inputPhone').focus();
	            return;
	        },
	        init: function init() {
	            var _this = this;
	            var params = {
	                advert_id: _this.advertId
	            };
	            _jquery2.default.ajax({
	                url: 'https://api.0168.net.cn/qiaosi/order/v3/init',
	                type: 'get',
	                data: params,
	                dataType: "json",
	                headers: {
	                    'Content-Type': 'application/json'
	                },
	                success: function success(res) {
	                    console.log(res.data);
	                }
	            });
	        },
	        getPageUrl: function getPageUrl() {
	            var _this = this;
	            var param = {
	                product: _this.productId,
	                channelid: _this.channelid,
	                advertId: _this.advertId,
	                unionSite: _this.unionSite
	            };
	
	            if (_this.isDebug == 1 && _baseMethod2.default.getQueryString("ip")) {
	                param['ip'] = _baseMethod2.default.getQueryString("ip");
	                param['isDebug'] = _this.isDebug;
	            }
	
	            if (localStorage.getItem('url') && localStorage.getItem("url_expire") > new Date().getTime()) {
	                _this.productUrl = localStorage.getItem('url');
	            } else {
	                _jquery2.default.ajax({
	                    url: 'https://api.0168.net.cn/qiaosi/page/v1',
	                    type: 'get',
	                    data: param,
	                    success: function success(res) {
	                        var toUrl = res.data;
	                        localStorage.setItem('url', toUrl);
	                        localStorage.setItem('url_expire', new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
	                        _this.productUrl = res.data;
	                    }
	                });
	            }
	        }
	    }
	};

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(543)
	
	/* script */
	__vue_exports__ = __webpack_require__(171)
	
	/* template */
	var __vue_template__ = __webpack_require__(1060)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-69bdca4c"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1060:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrap opti_wrap",
	    class: {
	      pd110: _vm.btnFixed
	    },
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('img', {
	    staticClass: "closeBtn",
	    attrs: {
	      "id": "closeBtn",
	      "src": "https://resource.0168.net.cn/activity-mall/h5/theme16/ic-confirm-close.png",
	      "onclick": "window.history.go(-1)"
	    }
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content",
	    attrs: {
	      "id": "content"
	    }
	  }, [_c('div', {
	    staticClass: "descDiv",
	    attrs: {
	      "id": "descDiv"
	    }
	  }, [_c('div', {
	    staticClass: "descTitle",
	    attrs: {
	      "id": "descTitle"
	    }
	  }, [_vm._v("活动规则")])]), _vm._v(" "), _c('div', {
	    staticClass: "contentText",
	    attrs: {
	      "id": "contentText"
	    }
	  }, [_c('p', [_vm._v("1、活动对象：2G/3G/4G/5G手机用户。")]), _vm._v(" "), _c('p', [_vm._v("2、活动内容：活动期间凡首次在本页面成功开通业务（业务资费：6元起/月，具体资费以短信为准）即可每月从腾讯视频VIP、爱奇艺VIP等热门权益中任选一种兑换领取和随机话费红包任性送（仅开通当月享有一次机会）。")]), _vm._v(" "), _c('p', [_vm._v("热门权益（15选1)：腾讯视频VIP月卡、优酷视频黄金会员月卡、爱奇艺黄金会员月卡、芒果TV会员月卡、PP视频会员月卡、哔哩哔哩会员月卡、网易云音乐黑胶会员月卡、QQ音乐绿钻豪华版月卡、酷狗音乐豪华VIP月卡、酷我音乐会员月卡、掌阅VIP月卡、知乎盐选会员月卡、Keep健身会员月卡、喜马拉雅VIP月卡、懒人听书会员月卡。")]), _vm._v(" "), _c('p', [_vm._v("3、礼品发放：")]), _vm._v(" "), _c('p', [_vm._v("（1）热门权益兑换方式：进入"), _c('a', {
	    attrs: {
	      "href": "https://mf.0168.net.cn/benefit-platform"
	    }
	  }, [_vm._v("https://mf.0168.net.cn/benefit-platform")]), _vm._v("，登录后，选择您需要的权益进行兑换。")]), _vm._v(" "), _c('p', [_vm._v("（2）话费权益兑换方式：进入"), _c('a', {
	    attrs: {
	      "href": "https://mf.0168.net.cn/benefit-platform"
	    }
	  }, [_vm._v("https://mf.0168.net.cn/benefit-platform")]), _vm._v("，登录后，选择话费面值，点击“立即兑换”即可直充到账。")]), _vm._v(" "), _c('p', [_vm._v("温馨提示：使用相关权益时，请遵守相应平台的用户服务协议和权益使用协议，如违反相关协议规定，运营商和联合权益提供方均有权单独进行处理，包括但不限于中止或终止提供其所属平台的服务及要求侵权赔偿等。")]), _vm._v(" "), _c('p', [_vm._v("4、注意事项：")]), _vm._v(" "), _c('p', [_vm._v("（1）每个手机号仅限参与一次，如当月不退订，次月自动续订；")]), _vm._v(" "), _c('p', [_vm._v("（2）本业务退订后视作放弃本活动福利礼品，未充值到账或未兑换的礼品将不再发放（福利礼品包括会员、代金券、话费等）；")]), _vm._v(" "), _c('p', [_vm._v("（3）已开通本业务的老用户不可再次参与本次推广活动。")]), _vm._v(" "), _c('p', [_vm._v("（4）权益领取周期为自然月，热门权益需用户手动领取，如当月热门权益未领取，次月无法补领上月权益，请及时领取。")]), _vm._v(" "), _c('p', [_vm._v("（5）未退订状态下，权益连续下发12个月；如发生退订，则次月起不再发放该权益。")]), _vm._v(" "), _c('p', [_vm._v("（6）此权益兑换活动仅适用于专属互联网渠道订购成功用户。")]), _vm._v(" "), _c('p', [_vm._v("5、退订方式：")]), _vm._v(" "), _c('p', [_vm._v("（1）联通退订方式：进入中国联通APP-服务-我已订购-增值业务-选择相关业务名称-退订，或者发送短信0000至10010，按提示内容退订； ")]), _vm._v(" "), _c('p', [_vm._v("（2）移动退订方式：发送短信0000至10086，按提示内容退订。 ")]), _vm._v(" "), _c('p', [_vm._v("（3）电信退订方式：发送短信00000至10001，按提示内容退订。")]), _vm._v(" "), _c('p', [_vm._v("6、由于产品价格可能出现临时调整，具体资费以实际扣费短信为准。")]), _vm._v(" "), _c('p', [_vm._v("7、如有疑问可致电客服热线："), _c('a', {
	    attrs: {
	      "href": "tel:4008008663"
	    }
	  }, [_vm._v("4008008663")]), _vm._v("进行咨询。")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "margin": "0px auto"
	    },
	    attrs: {
	      "id": "linkGZH"
	    }
	  }, [_c('a', {
	    staticStyle: {
	      "color": "rgb(0, 0, 81)",
	      "font-size": "12px"
	    },
	    attrs: {
	      "href": "https://mf.0168.net.cn/benefit-platform/"
	    }
	  }, [_vm._v("福利兑换中心")])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/h5/indexaqy_activity.b08f753d3914e1c12dac.js